// extracted by mini-css-extract-plugin
export default {"container":"kK-z","topReviewHeading":"lK-z","criticalReview":"mK-z","favorableReview":"nK-z","vsSeparator":"oK-z"};